<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Apply  for Leave
                </h3>
                <!-- <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Leave  Type</router-link
                      ></li>
                  </ol>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card pb-2">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-2  common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="las las la-user-check i_icon_st font-medium-5"></em>
                    </div>
                  </div>

                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                      Leave Type
                  </h4>
                </div>
              </div>
              <div class="row mx-0">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                          <label class="form-label text-left w-100"> Select Leave Type </label>
                          <treeselect placeholder="Leave type" id=""  :options="leave_type" />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                          <label class="form-label text-left w-100" > Start Day </label>
                          <treeselect placeholder="Full Day" id=""  :options="[]" />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                          <label class="form-label text-left w-100" > End Day </label>
                          <treeselect placeholder="Full Day" id=""   :options="[]"/>
                        </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="ticket_type"> From  </label>
                        <date-picker placeholder="From Date" valueType="format" class="startdate w-100" ></date-picker>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="ticket_type">  To </label>
                        <date-picker placeholder="End Date" valueType="format" class="startdate w-100" ></date-picker>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                          <label class="form-label text-left w-100"> Leave Reason  </label>
                          <treeselect placeholder="Not Well" id="" :options="leave_reasons"  />
                        </div>
                       
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="description"> Description <span class="requiredField">*</span></label>
                        <textarea class="form-control" id="description" rows="2"  placeholder="Enter  Descriptions"></textarea>
                      </div>
                     
                      <div class="col-12 col-sm-6 col-md-6 col-lg-8 text-right mt-4  home_das_all_buttons_style mobileview_b_8 mt-2">
                          <button type="submit" class="btn btn-outline-primary  waves-effect  mr-0" >
                              Submit
                          </button>
                      </div>
              </div>
            </div>
          </section>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../utils/searchMasterNameList";
import common_methods from "../../utils/common_methods";
import axios from "axios"
import CONSTANT from "../../constants.js"
import Pagination from 'vue-pagination-2'

export default {
  name: "LeaveApply",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isListLoading: false,
      isLoading: false,
      query_list: [],
      list: [],
      leave_type: [
        {
          id: 'Privilege',
          label: 'privilege', 
        },
        {
          id: 'Paid',
          label: 'paid'
        },
        {
          id: 'Unpaid',
          label: 'Unpaid'
        }
      ],
      leave_reasons: [
        {
          id: 'personal',
          label: 'Personal'
        },
        {
          id: 'Not Well',
          label: 'Not Well'
        },
        {
          id: 'Outdoor',
          label: 'Outdoor'
        },
      ],  
      totalcount: 0,
      pageCount: 0,
      page: 1,
      pagelimit: CONSTANT.LIMIT,
      currPageNum: 0,
      pageoffset: 1,
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
    Pagination,
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    $(window).on("load", function () {
      if (feather) {
        feather.replace({
          width: 14,
          height: 14,
        });
      }
    });
  },
  created() {
    this.getTickets()
  },
  methods: {
    getTickets() {
      this.isListLoading = true
      let url = "/support/tickets"
      let payload = {
        page: this.page,
        rows: this.pagelimit
      }
      this.makeRequest("POST", url, payload)
        .then(result => {
          this.isListLoading = false
          this.list = result.data.data.rows
          this.totalcount = result.data.data.count
          this.pageCount = Math.ceil(result.data.data.count / this.pagelimit)
        })
        .catch(e => {
          this.isListLoading = false
          this.displayError(e)
        })
    },
    handlePageChange(pageNum) {
      this.pageoffset = pageNum
      this.currPageNum = pageNum - 1
      this.getTickets();
      setTimeout(function(){
          $('html, body').animate({
              scrollTop: $("#list").offset().top -70
          });
      }, 500);
    }
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}

</style>
